import { computed, type ComputedRef } from 'vue'
import type {
    BookingStatusAvailableResult,
    CourseBookingStatus
} from '~/resources/graphql/graphql'
import { useViewer } from '#imports'

export function useCourseWaitlistBookingMessage(
    waitlistEnabled: ComputedRef<boolean>,
    selectedCourse: ComputedRef<{
        bookingStatus: CourseBookingStatus
        bookingStatusAvailable: BookingStatusAvailableResult[]
        capacityResult: {
            isWaitlistFull: boolean
        }
    } | null>
) {
    const viewer = useViewer()

    return computed(() => {
        if (selectedCourse.value === null) {
            return null
        }

        // If booking status is closed
        if (selectedCourse.value.bookingStatus === 'WAITLIST') {
            if (viewer.value) {
                if (selectedCourse.value.bookingStatusAvailable.length === 0) {
                    let message = 'You have selected a course that is full'

                    if (waitlistEnabled.value) {
                        if (
                            selectedCourse.value.capacityResult.isWaitlistFull
                        ) {
                            message += '. The waitlist is currently full.'
                        } else {
                            message += '. Join the waitlist below.'
                        }
                    }

                    return {
                        type: 'message',
                        message
                    }
                }
            } else {
                return {
                    type: 'waitlisted',
                    message:
                        'Booking only available to waitlisted customers. Sign in to view your spot or join the waitlist'
                }
            }
        }

        return null
    })
}
